import React from 'react';
import {useSelector} from 'react-redux';

const WithPermission = <T extends Record<string, any>>(
  Component: React.ComponentType<T>,
  module: string,
  action: string
): ((props: T) => JSX.Element) => {
  const ComponentWithPermission = (props: T): JSX.Element => {
    const {userPermissions, groupId} = useSelector((state: any) => state.auth);

    const hasPermission = !!userPermissions?.[groupId]?.[module]?.[action];
    if (!hasPermission) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <React.Fragment />;
    }
    return <Component {...props} />;
  };

  return ComponentWithPermission;
};

export default WithPermission;
